import React from 'react';
import './css/LoadingModal.css';

const LoadingModal = () => {
  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div className="spinner"></div>
        <p>Loading, please wait...</p>
      </div>
    </div>
  );
};

export default LoadingModal;
